import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PoliceLocalCap, PoliceNationalCap, FirefighterHelmet, } from './OppositionHeadwear';
function Headwear({ opposition, size }) {
    const capWidth = size * 0.78;
    // Italic "A" leans right — nudge the cap slightly right and up
    const common = {
        position: 'absolute',
        left: '50%',
        top: 0,
        transform: `translate(calc(-50% + ${size * 0.06}px), -70%)`,
        pointerEvents: 'none',
        lineHeight: 0,
    };
    if (opposition === 'policia_local') {
        return _jsx("span", { style: common, children: _jsx(PoliceLocalCap, { size: capWidth }) });
    }
    if (opposition === 'policia_nacional') {
        return _jsx("span", { style: common, children: _jsx(PoliceNationalCap, { size: capWidth }) });
    }
    if (opposition === 'bomberos') {
        return _jsx("span", { style: common, children: _jsx(FirefighterHelmet, { size: capWidth }) });
    }
    return null;
}
export function ApoloLogo({ opposition = 'none', size = 32, color = 'currentColor', className, style, }) {
    const hasHeadwear = opposition !== 'none';
    return (_jsxs("span", { className: className, style: {
            fontFamily: '"ITC Tiffany Std", Georgia, serif',
            fontStyle: 'italic',
            fontWeight: 900,
            fontSize: `${size}px`,
            letterSpacing: '0.01em',
            lineHeight: 1,
            color,
            display: 'inline-flex',
            alignItems: 'baseline',
            ...style,
        }, children: [_jsxs("span", { style: { position: 'relative', display: 'inline-block' }, children: ["A", hasHeadwear && _jsx(Headwear, { opposition: opposition, size: size })] }), "POLO"] }));
}
//# sourceMappingURL=ApoloLogo.js.map